import { getDataLanguage } from '@/services/axios'
import { isObjEmpty, isStrEmpty } from '@/utils/utils'

export default {
    data(): any {
        return {}
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}, isUpperCase = true) {
            if (!text) {
                return
            }
            let language: any = getDataLanguage() || ''
            language = !isStrEmpty(language) ? JSON.parse(language) : {}
            const rsText = text.toLowerCase()
            let translatedText: any = !isStrEmpty(language[rsText]) ? language[rsText] : rsText

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    const pattern = new RegExp('\\[' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\]', 'g')
                    translatedText = translatedText.replace(pattern, xargs[key])
                }
            }

            if (isUpperCase) {
                translatedText = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            }

            return translatedText
        },
    },
}
